import { RefiHttpClient } from '@cof/refi-web-sdk';
import { DebugService } from './debug.service.js';
import { stratum } from '../../../constants/stratum.js';

class _ExperimentService {
  constructor() {
    this.debug = new DebugService('ExperimentService');
    this.http = new RefiHttpClient();
    this._experiments = [];
    this._isIconicAndToggledOn = false;
    this._isIconicEtitleAndToggledOn = false;
    this._isCxtFlowAndToggledOn = false;
    this._isCombinedHardpullContractToggledOn = false;
    this._isDelayedHardpullToggledOn = false;
    this.abTest = null;
    this._abTests = {
      name: 'contract-ab-tests',
      variationIds: [],
      testGroup: '',
      testWeight: 1,
    };
  }

  updateExperiments(newExperiments, removeExperiments = []) {
    stratum.endAbTest(this.abTest);
    const configuredExperiments = newExperiments.map(experiment => experiment.toLowerCase());
    const updatedExperiments = this._experiments.filter(experiment => !removeExperiments.includes(experiment));
    this._experiments = Array.from(new Set(updatedExperiments.concat(configuredExperiments)));
    this._abTests.variationIds = this._experiments;
    this.abTest = stratum.startAbTest(this._abTests);
  }

  get experiments() {
    return this._experiments;
  }

  set experiments(experiments) {
    this._experiments = experiments;
  }

  get isIconicAndToggledOn() {
    return this._isIconicAndToggledOn;
  }

  set isIconicAndToggledOn(isIconicAndToggledOn) {
    this._isIconicAndToggledOn = isIconicAndToggledOn;
  }

  get isCxtFlowAndToggledOn() {
    return this._isCxtFlowAndToggledOn;
  }

  set isCxtFlowAndToggledOn(isCxtFlowAndToggledOn) {
    this._isCxtFlowAndToggledOn = isCxtFlowAndToggledOn;
  }

  get isIconicETitleAndToggleOn() {
    return this._isIconicEtitleAndToggledOn;
  }

  set isIconicETitleAndToggleOn(isIconicAndToggledOn) {
    this._isIconicEtitleAndToggledOn = isIconicAndToggledOn;
  }

  get isCombinedHardpullContractToggledOn() {
    return this._isCombinedHardpullContractToggledOn;
  }

  set isCombinedHardpullContractToggledOn(isCombinedHardpullContract) {
    this._isCombinedHardpullContractToggledOn = isCombinedHardpullContract;
  }

  get isDelayedHardpullToggledOn() {
    return this._isDelayedHardpullToggledOn;
  }

  set isDelayedHardpullToggledOn(isDelayedHardpullToggledOn) {
    this._isDelayedHardpullToggledOn = isDelayedHardpullToggledOn;
  }
}
export const ExperimentService = new _ExperimentService();
